<template>
    <div v-if="model">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :end-validations="validations.periodo"
                            :range-inline="false"
                            :start-validations="validations.periodo"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.unidades"
                            @change="handleUnidadeChange"
                            default-option-text="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.infraestruturas"
                            @change="handleInfraestruturaChange"
                            default-option-text="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.especialidades"
                            @change="handleEspecialidadeChange"
                            default-option-text="Todas"
                            label="Especialidade"
                            show-default-option
                            text-field="nome"
                            v-model="model.especialidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.usuarios"
                            @change="handleUsuarioChange"
                            default-option-text="Todos"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.origens"
                            default-option-text="Todas"
                            label="Origem"
                            show-default-option
                            v-model="model.origem"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <template v-if="data">
            <rkm-area
                no-margin-top
                title="Resultado"
            >
                <template v-slot:trailing>
                    <rkm-button
                        @click="print"
                        color="info"
                        small
                        title="Imprimir"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>
                </template>

                <rkm-table
                    :fields="fields"
                    :items="data.itens"
                    hide-pagination
                >
                    <template v-slot:thead-top>
                        <rkm-tr>
                            <rkm-th colspan="4"></rkm-th>

                            <rkm-th
                                v-if="!onlyDemandasEspontaneas"
                                class="text-center"
                                colspan="7"
                            >
                                Agendamento
                            </rkm-th>

                            <rkm-th
                                v-if="!onlyAgendamentos"
                                class="text-center"
                                colspan="3"
                            >
                                Demanda espontânea
                            </rkm-th>
                        </rkm-tr>

                        <rkm-tr>
                            <rkm-th colspan="4"></rkm-th>

                            <template v-if="!onlyDemandasEspontaneas">
                                <rkm-th
                                    class="text-center"
                                    colspan="2"
                                >
                                    Realizadas
                                </rkm-th>

                                <rkm-th
                                    class="text-center"
                                    colspan="2"
                                >
                                    Faltas do paciente
                                </rkm-th>

                                <rkm-th
                                    class="text-center"
                                    colspan="2"
                                >
                                    Faltas do médico
                                </rkm-th>

                                <rkm-th></rkm-th>
                            </template>

                            <template v-if="!onlyAgendamentos">
                                <rkm-th
                                    class="text-center"
                                    colspan="2"
                                >
                                    Realizadas
                                </rkm-th>

                                <rkm-th></rkm-th>
                            </template>
                        </rkm-tr>
                    </template>

                    <template v-slot:cell(agendamentoPorcentagemAtendimentoRealizado)="{item}">
                        {{item.agendamentoPorcentagemAtendimentoRealizado}}%
                    </template>

                    <template v-slot:cell(agendamentoPorcentagemFaltaPaciente)="{item}">
                        {{item.agendamentoPorcentagemFaltaPaciente}}%
                    </template>

                    <template v-slot:cell(agendamentoPorcentagemFaltaMedico)="{item}">
                        {{item.agendamentoPorcentagemFaltaMedico}}%
                    </template>

                    <template v-slot:cell(demandaEspontaneaPorcentagemAtendimentoRealizado)="{item}">
                        {{item.demandaEspontaneaPorcentagemAtendimentoRealizado}}%
                    </template>

                    <template v-slot:custom-foot>
                        <rkm-tr>
                            <rkm-th colspan="4"></rkm-th>

                            <template v-if="!onlyDemandasEspontaneas">
                                <rkm-th class="text-center">
                                    {{data.totalizadores.agendamentoQuantidadeAtendimentoRealizado}}
                                </rkm-th>

                                <rkm-th class="text-center">
                                    {{data.totalizadores.agendamentoPorcentagemAtendimentoRealizado}}%
                                </rkm-th>

                                <rkm-th class="text-center">
                                    {{data.totalizadores.agendamentoQuantidadeFaltaPaciente}}
                                </rkm-th>

                                <rkm-th class="text-center">
                                    {{data.totalizadores.agendamentoPorcentagemFaltaPaciente}}%
                                </rkm-th>

                                <rkm-th class="text-center">
                                    {{data.totalizadores.agendamentoQuantidadeFaltaMedico}}
                                </rkm-th>

                                <rkm-th class="text-center">
                                    {{data.totalizadores.agendamentoPorcentagemFaltaMedico}}%
                                </rkm-th>

                                <rkm-th class="text-center">
                                    {{data.totalizadores.agendamentoQuantidadeAtendimento}}
                                </rkm-th>
                            </template>

                            <template v-if="!onlyAgendamentos">
                                <rkm-th class="text-center">
                                    {{data.totalizadores.demandaEspontaneaQuantidadeAtendimentoRealizado}}
                                </rkm-th>

                                <rkm-th class="text-center">
                                    {{data.totalizadores.demandaEspontaneaPorcentagemAtendimentoRealizado}}%
                                </rkm-th>

                                <rkm-th class="text-center">
                                    {{data.totalizadores.demandaEspontaneaQuantidadeAtendimento}}
                                </rkm-th>
                            </template>
                        </rkm-tr>
                    </template>
                </rkm-table>
            </rkm-area>
        </template>
    </div>
</template>

<script>
// Mixins.
import {error, file, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                periodo: {required: true},
            }
        },
        onlyAgendamentos() {
            return this.model && this.model.origem === 'agendamento'
        },
        onlyDemandasEspontaneas() {
            return this.model && this.model.origem === 'demanda-espontanea'
        },
        fields() {
            const fields = [
                {key: 'usuarioNome', label: 'Profissional', sortable: true},
                {key: 'especialidadeNome', label: 'Especialidade', sortable: true},
                {key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true},
                {key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true},
            ]

            if (!this.onlyDemandasEspontaneas) {
                fields.push({class: 'text-center', key: 'agendamentoQuantidadeAtendimentoRealizado', label: 'Quantidade'})
                fields.push({class: 'text-center', key: 'agendamentoPorcentagemAtendimentoRealizado', label: '%'})
                fields.push({class: 'text-center', key: 'agendamentoQuantidadeFaltaPaciente', label: 'Quantidade'})
                fields.push({class: 'text-center', key: 'agendamentoPorcentagemFaltaPaciente', label: '%'})
                fields.push({class: 'text-center', key: 'agendamentoQuantidadeFaltaMedico', label: 'Quantidade'})
                fields.push({class: 'text-center', key: 'agendamentoPorcentagemFaltaMedico', label: '%'})
                fields.push({class: 'text-center', key: 'agendamentoQuantidadeAtendimento', label: 'Total', sortable: true})
            }

            if (!this.onlyAgendamentos) {
                fields.push({class: 'text-center', key: 'demandaEspontaneaQuantidadeAtendimentoRealizado', label: 'Quantidade'})
                fields.push({class: 'text-center', key: 'demandaEspontaneaPorcentagemAtendimentoRealizado', label: '%'})
                fields.push({class: 'text-center', key: 'demandaEspontaneaQuantidadeAtendimento', label: 'Total', sortable: true})
            }

            return fields
        }
    },
    created() {
        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.ambulatorio'),
            relatorioEstatisticoStatus: this.getConectaSusRepository('ambulatorio.relatorioEstatisticoStatus'),
        }

        this.load()
    },
    data() {
        return {
            form: null,
            data: null,
            model: null,
            others: {moment},
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.relatorioEstatisticoStatus.create()
                .then((response) => {
                    this.form = response.data.form
                    this.model = response.data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search() {
            const request = {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                especialidadeId: this.model.especialidadeId,
                usuarioId: this.model.usuarioId,
                origem: this.model.origem,
            }

            this.setLoading()

            this.repositories.relatorioEstatisticoStatus.index(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.data = Object.assign(response.data))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.form.origens = []

            this.model.periodo = {
                start: null,
                end: null,
            }

            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.model.origem = null

            this.data = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        print() {
            this.setLoading()

            const request = {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                especialidadeId: this.model.especialidadeId,
                usuarioId: this.model.usuarioId,
                origem: this.model.origem,
            }

            this.repositories.impressao.relatorioEstatisticoStatus(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        handleUnidadeChange(value) {
            this.form.infraestruturas = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.form.origens = []
            this.model.infraestruturaId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.model.origem = null

            if (value === null) {
                return
            }

            const request = {
                listar: 'infraestruturas',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: value,
            }

            this.setLoading()

            this.repositories.relatorioEstatisticoStatus.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                    this.form.especialidades = Object.assign(response.data.especialidades)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.origens = Object.assign(response.data.origens)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleInfraestruturaChange(value) {
            this.form.especialidades = []
            this.form.usuarios = []
            this.form.origens = []
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.model.origem = null

            if (value === null) {
                return
            }

            const request = {
                listar: 'especialidades',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: value,
            }

            this.setLoading()

            this.repositories.relatorioEstatisticoStatus.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.especialidades = Object.assign(response.data.especialidades)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.origens = Object.assign(response.data.origens)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleEspecialidadeChange(value) {
            this.form.usuarios = []
            this.form.origens = []
            this.model.usuarioId = null
            this.model.origem = null

            if (value === null) {
                return
            }

            const request = {
                listar: 'usuarios',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                especialidadeId: value,
            }

            this.setLoading()

            this.repositories.relatorioEstatisticoStatus.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.origens = Object.assign(response.data.origens)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUsuarioChange(value) {
            this.form.origens = []
            this.model.origem = null

            if (value === null) {
                return
            }

            const request = {
                listar: 'origens',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                especialidadeId: this.model.especialidadeId,
                usuarioId: value,
            }

            this.setLoading()

            this.repositories.relatorioEstatisticoStatus.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.origens = Object.assign(response.data.origens)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [error, file, repository, stringCase],
    watch: {
        model: {
            deep: true,
            handler() {
                this.data = null
            }
        },
        'model.periodo': {
            deep: true,
            handler(value) {
                this.form.unidades = []
                this.form.infraestruturas = []
                this.form.especialidades = []
                this.form.usuarios = []
                this.form.origens = []
                this.model.unidadeId = null
                this.model.infraestruturaId = null
                this.model.especialidadeId = null
                this.model.usuarioId = null
                this.model.origem = null

                if (value.start === null || value.end === null)  {
                    return
                }

                const request = {
                    listar: 'unidades',
                    periodo: {
                        start: this.others.moment(value.start).format('DD/MM/YYYY'),
                        end: this.others.moment(value.end).format('DD/MM/YYYY'),
                    },
                }

                this.setLoading()

                this.repositories.relatorioEstatisticoStatus.list(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.form.unidades = Object.assign(response.data.unidades)
                        this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                        this.form.especialidades = Object.assign(response.data.especialidades)
                        this.form.usuarios = Object.assign(response.data.usuarios)
                        this.form.origens = Object.assign(response.data.origens)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            },
        },
    },
}
</script>